<template>
    <div class="talent-level-container">
        <!-- 搜索头部分 start -->
        <div class="search">
            <div class="control">
                <label class="label inline-block r-top">奖品类型：</label>
                <el-select v-model="search.type" placeholder="请选择">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="control">
                <label class="label inline-block r-top">奖品ID：</label>
                <input class="input width-2" type="text" v-model="search.prizeId">
            </div>
            <div class="control">
                <label class="label inline-block r-top">用户ID：</label>
                <input class="input width-2" type="text" v-model="search.userId">
            </div>
            <div class="control">
                <label class="label inline-block r-top">时间</label>
                <el-date-picker
                        v-model="search.createTimeStart"
                        type="datetime"
                        placeholder="开始时间"
                        align="right">
                </el-date-picker>
                <span class="r-top">~</span>
                <el-date-picker
                        v-model="search.createTimeEnd"
                        type="datetime"
                        placeholder="结束时间"
                        align="right">
                </el-date-picker>
            </div>
            <div class="control">
                <button class="button is-primary width-2" @click="doSearch">搜索</button>
            </div>
        </div>
        <!-- 搜索头部分 end -->
        <div class="list-wrap">
            <div class="clearfix" v-if="count>0">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
            <div class="tile is-parent">
                <article class="tile is-child box">
                    <table class="table is-bordered">
                        <thead>
                        <tr>
                            <th>奖品ID</th>
                            <th>奖品标题</th>
                            <th>奖品类型</th>
                            <th>用户手机号</th>
                            <th>中奖用户名</th>
                            <th>中奖用户ID</th>
                            <th>中奖时间</th>
                            <th>操作备注</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in tableData" :key="index">
                            <td>{{item.prizeId}}</td>
                            <td>{{item.title}}</td>
                            <td>
                                <span v-if="item.type==1">优惠券</span>
                                <span v-if="item.type==2">其他</span>
                            </td>
                            <td>{{item.phone}}</td>
                            <td>{{item.username}}</td>
                            <td>{{item.userId}}</td>
                            <td>{{item.createTime}}</td>
                            <td style="width:300px">
                                <input type="text" style="width:300px" v-model="item.remark" @change="setRemark(item)">
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </article>
            </div>
            <div class="clearfix" v-if="count>0">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
    import { formatDate } from 'UTILS/date';
    export default{
        data(){
            return{
                count: 0,
                tableData:[],
                search:{
                    pageSize: 20,
                    page: 1,
                    activityId:'',
                    userId:null,
                    createTimeStart:null,
                    createTimeEnd:null,
                    type:null,
                    prizeId:null,
                },
                options: [{
                    value: 1,
                    label: "优惠券"
                }, {
                    value: 2,
                    label: "其他"
                }],
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.search.activityId = parseInt(this.$route.query.activityId);
                this.getPrizeRecordList(this.search);
            })
        },
        methods:{
            /*
            * 点击删除触发
            * */

            handleCurrentChange(value) {
                if(this.search.page !== value){
                    this.search.page = value;
                    this.getPrizeRecordList(this.search);
                }
            },
            getPrizeRecordList(params) {
                let searchParams=Object.assign({},params);
                if(searchParams.createTimeStart){
                    searchParams.createTimeStart=formatDate(new Date(searchParams.createTimeStart).getTime(),'yyyy-MM-dd hh:mm:ss')
                }
                if(searchParams.createTimeEnd){
                    searchParams.createTimeEnd=formatDate(new Date(searchParams.createTimeEnd).getTime(),'yyyy-MM-dd hh:mm:ss')
                }
                HttpRequest.get('/admin.php?method=cartactivity.getPrizeRecord', searchParams,true).then((response) => {
                    this.tableData = response.data.list;
                    this.count = response.data.count;
                })
            },
            doSearch(){
                this.search.page = 1;
                this.getPrizeRecordList(this.search);
            },
            setRemark(item){
                let params={
                    activityId:item.activityId,
                    ruleId:item.ruleId,
                    userId:item.userId,
                    remark:item.remark

                };
                HttpRequest.get('/admin.php?method=cartactivity.setPrizeRecordRemark', params,true).then((response) => {
                    if (response.data.success) {
                        this.$message('保存成功')
                    }else{
                        this.$message(response.data.msg)
                    }
                })
            }
        }
    }
</script>
<style lang="less" scoped>
    .list-box{
        margin-bottom: 20px;
    }
    .remark-col{
        width: 300px;
    }
    .marginRight{
        margin-right: 5px;
        margin-bottom: 5px;
    }
</style>
